export default __webpack_public_path__ + "images/0aeda09c690a673ad156e771abbb3577-tennis.jpg";